import React, { useEffect, useState } from "react";
import _ from "lodash/fp";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import { email, mobileRegex } from "../../common/constants/regex";
import {
  loginAction,
  getDepartment,
  verificationOTP,
  generateOTP,
} from "../actions/loginAction";
import "../../styles/login.css";
import { generateCaptcha } from "../../common/actions/commonActions";
import login from "../labels/login_en.json";
import userLabel from "../../usermanagement/labels/users_en.json";
import { toastr } from "react-redux-toastr";
import { EPMS_API_CAPTCHA_URL as captchaURL } from "../../configuration";
import { CAPTCHA_URL } from "../../common/constants/baseUrls";
import { el } from "date-fns/locale";


export default function Login(props) {

  const currentDomain = window.location.hostname;

  const domainConfig = captchaURL && captchaURL.length > 0 && captchaURL.find((e) => currentDomain === e.key);

  let captchaUrl;

  if (domainConfig) {
    captchaUrl = domainConfig.baseUrl;
  } else {
    captchaUrl = CAPTCHA_URL;
  }

  const {
    register,
    handleSubmit,
    formState,
    errors,
    watch,
    setValue,
    setError,
  } = useForm({
    mode: "onChange",
  });
  const dispatch = useDispatch();

  const {
    captchaId,
    allDepartments,
    loginOTPSResponse,
    verifyEmailOtpFlag,
    verifyMobileOtpFlag,
    otpVerificationStatusEmail,
    otpVerificationStatusMobile,
    bothOtpVerificationStatus,
    loginUserName,
    otpData,
  } = useSelector((state) => state.common, shallowEqual);

  const [departmentList, setDeparmentList] = useState("");
  const [onChangeVerification, setonChangeVerification] = useState("");
  const [onChangeDept, setonChangeDept] = useState(false);
  const [onChangeUserName, setonChangeUserName] = useState(false);
  const [otpButtonDisabled, setotpButtonDisabled] = useState(false);

  const [selectedtype, setSelectedType] = useState();

  let emailId = watch("emailId");
  let mobileNo = watch("mobileNo");

  useEffect(() => {
    dispatch(generateCaptcha());
    dispatch(getDepartment());
    setValue('usertype', 'mobile');
  }, []);
  useEffect(() => {
    setonChangeVerification(true);
  }, [verifyEmailOtpFlag, verifyMobileOtpFlag]);
  useEffect(() => {
    startTimeCount(selectedtype);
  }, [otpData, selectedtype]);

  const startTimeCount = (type) => {
    let x = 0;
    let start = 0;
    let end = 0;
    otpData.map((e) => {
      if (
        e.type === type ||
        type === "both" ||
        type === "email" ||
        type === "mobile"
      ) {
        x = parseInt(e.expiryDuration);
        start = x;
        end = start;
      }
    });

    if (type === "both" || type === "email" || type === "mobile") {
      const createClock = setInterval(displayTime, 1000);
      function displayTime() {
        start = end;

        end = start - 1;
        var timerElement = document.getElementById("timer");

        if (timerElement !== null) {
          if (start != null) {
            timerElement.textContent = start;
          }
        }

        if (start === 0) {
          clearInterval(createClock);
          setotpButtonDisabled(false);
        } else {
          setotpButtonDisabled(true);
        }
      }
    }
  };

  const handleChangeDepartment = (e) => {
    setDeparmentList(e.target.value);
    if (
      bothOtpVerificationStatus === true ||
      otpVerificationStatusEmail === true ||
      otpVerificationStatusMobile === true
    ) {
      setonChangeVerification(false);
      setonChangeDept(false);
    }
  };

  const handleChangeUsername = (e) => {
    if (
      bothOtpVerificationStatus === true ||
      otpVerificationStatusEmail === true ||
      otpVerificationStatusMobile === true
    ) {
      setonChangeVerification(false);
      setonChangeUserName(true);
      setonChangeDept(true);
    }
  };
  // const getOTP = (type) => {
  //   let selectedDept = allDepartments.find((x) => x.id == departmentList);

  //   if (
  //     selectedDept.sendLoginOtpTo === "mobile" &&
  //     watch("usertype") !== "mobile"
  //   ) {
  //     toastr.info(login.Please_login_with_registered_mobile);
  //   } else if (
  //     selectedDept.sendLoginOtpTo === "email" &&
  //     watch("usertype") !== "email"
  //   ) {
  //     toastr.info(login.Please_login_with_registered_email);
  //   } else {
  //     if (watch("emailId")) {
  //       dispatch(
  //         generateOTP(
  //           {
  //             email: emailId && emailId.trim(),
  //             mobile: "",
  //             type: login.email,
  //             otpFor: login.logintext,
  //             sendOtpTo: selectedDept.sendLoginOtpTo,
  //             sendOtpDifferent: selectedDept.sendLoginOtpDifferent,
  //             departmentName: selectedDept.name,
  //             depatmentId: selectedDept.id,
  //           },
  //           props
  //         )
  //       );
  //       setValue("OTP_email", "", { shouldDirty: true });
  //       setValue("OTP_mobile", "", { shouldDirty: true });
  //       setotpButtonDisabled(true);

  //       setSelectedType(selectedDept.sendLoginOtpTo);
  //     } else if (watch("mobileNo")) {
  //       dispatch(
  //         generateOTP(
  //           {
  //             email: "",
  //             mobile: mobileNo,
  //             type: login.mobile,
  //             otpFor: login.logintext,
  //             sendOtpTo: selectedDept.sendLoginOtpTo,
  //             sendOtpDifferent: selectedDept.sendLoginOtpDifferent,
  //             departmentName: selectedDept.name,
  //             depatmentId: selectedDept.id,
  //           },
  //           props
  //         )
  //       );
  //       setValue("OTP_email", "", { shouldDirty: true });
  //       setValue("OTP_mobile", "", { shouldDirty: true });
  //       setotpButtonDisabled(true);

  //       setSelectedType(selectedDept.sendLoginOtpTo);
  //     } else {
  //       setError("mobileNo", { type: "required" });
  //       setError("emailId", { type: "required" });
  //     }
  //   }
  // };

  // const verificationLoginEmailOTPs = (type) => {
  //   let otpid;
  //   let otptype;
  //   let userName = emailId ? emailId.trim().toLowerCase() : mobileNo;
  //   loginOTPSResponse.map((ele, key) => {
  //     if (ele.type === type) {
  //       otpid = ele.id;
  //       otptype = ele.type;
  //     }
  //     return;
  //   });
  //   if (watch("OTP_email") || watch("OTP_mobile")) {
  //     let reqBody = {
  //       username: userName,
  //       otpId: otpid,
  //       otpType: otptype,
  //       enteredOtp: watch("OTP_email"),
  //     };
  //     dispatch(verificationOTP(reqBody));
  //   } else {
  //     setError("OTP_email", { type: "required" });
  //   }
  // };

  // const verificationLoginMobileOTPs = (type) => {
  //   let otpid;
  //   let otptype;
  //   let userName = emailId ? emailId.trim().toLowerCase() : mobileNo;
  //   loginOTPSResponse.map((ele, key) => {
  //     if (ele.type === type) {
  //       otpid = ele.id;
  //       otptype = ele.type;
  //     }
  //     return;
  //   });
  //   if (watch("OTP_mobile") || watch("OTP_email")) {
  //     let reqBody = {
  //       username: userName,
  //       otpId: otpid,
  //       otpType: otptype,
  //       enteredOtp: watch("OTP_mobile"),
  //     };
  //     dispatch(verificationOTP(reqBody));
  //   } else {
  //     setError("OTP_mobile", { type: "required" });
  //   }
  // };

  const onSubmit = (data, e) => {

    data.otpVerificationStatusFlag = "";
    let selectedDept = allDepartments.find((x) => x.id == departmentList);
    if (
      bothOtpVerificationStatus === true &&
      selectedDept.sendLoginOtpTo === "both" &&
      onChangeVerification === true
    ) {
      data.otpVerificationStatusFlag =
        otpVerificationStatusEmail && otpVerificationStatusMobile;
    } else {
      if (
        (otpVerificationStatusEmail === true &&
          selectedDept.sendLoginOtpTo === "email" &&
          onChangeVerification === true) ||
        (otpVerificationStatusMobile === true &&
          selectedDept.sendLoginOtpTo === "mobile" &&
          onChangeVerification === true)
      ) {
        data.otpVerificationStatusFlag = true;
      } else if (
        loginUserName === data.mobileNo ||
        (loginUserName === data.emailId && onChangeDept && onChangeUserName)
      ) {
        data.otpVerificationStatusFlag = true;
      }
    }
    data.department = selectedDept.name;

    dispatch(loginAction(captchaId, data, props));
  };

  const reDirectToForgotPassword = () => { };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="row d-flex mt-4 ml-0 mr-0">
        <div className="col-md-2 border border-light"></div>
        <div className="col-md-8 border border-light bgcolor-fff">
          <div className="bold-text-box">
            <span className="bold-text">
              <b>{login.ADMIN_LOGIN}</b>{" "}
            </span>
          </div>
          <hr className="m-0 p-0" />
          <div className="row mb--20">
            <div className="form-group col-md-6 box">
              <div className="col-md-12 text-center m-10">
                <label className="pos-relative tp-12 rt-30 mr-10">
                  <input
                    type="radio"
                    className="radio"
                    name="usertype"
                    value="email"
                    ref={register({ required: false })}
                  />
                  &nbsp;{login.Email_ID}
                </label>
                <label className="pos-relative tp-12 rt-30 mr-10">
                  <input
                    type="radio"
                    className="radio"
                    name="usertype"
                    value="mobile"
                    ref={register({ required: false })}
                  />
                  &nbsp;{login.Mobile_Number}
                </label>
              </div>
            </div>
          </div>
          <div className="row d-flex justify-content-center m-10">
            <div className="form-group col-md-6 box">
              <div className="row">
                {watch("usertype") === "email" ? (
                  <div className="form-group col-md-12">
                    <label className="LeftText">
                      {" "}
                      {login.Email_ID}
                      <span className="color-red">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="emailId"
                      name="emailId"
                      ref={register({ required: true, pattern: email })}
                      onChange={handleChangeUsername}
                    />
                    {_.get("emailId.type", errors) === "required" && (
                      <p className="errorText">
                        {login.validationMessage.ONLY_EMAIL_REQUIRED}
                      </p>
                    )}
                    {_.get("emailId.type", errors) === "pattern" && (
                      <p className="errorText">
                        {login.validationMessage.EMAIL_PATTERN}
                      </p>
                    )}
                  </div>
                ) : (
                  ""
                )}
                {watch("usertype") === "mobile" ? (
                  <div className="form-group col-md-12">
                    <label className="LeftText">
                      {login.Mobile_Number}
                      <span className="errorText">*</span>
                    </label>
                    <div className="input-group">
                      <input
                        className="form-control"
                        id="registrationFormControlInput1"
                        type="text"
                        name="mobileNo"
                        ref={register({ required: true, pattern: mobileRegex })}
                        onChange={handleChangeUsername}
                      />
                    </div>
                    {_.get("mobileNo.type", errors) === "required" && (
                      <p className="errorText">
                        {login.validationMessage.MOBILE_REQ}
                      </p>
                    )}
                    {_.get("mobileNo.type", errors) === "pattern" && (
                      <p className="errorText">
                        {login.validationMessage.MOBILE_PATTERN}
                      </p>
                    )}
                  </div>
                ) : (
                  ""
                )}

                <div className="form-group col-md-12">
                  <label className="LeftText">
                    {" "}
                    {userLabel.DEPARTMENT} <span className="color-red">*</span>
                  </label>
                  <div className="input-group">
                    <select
                      className="form-control"
                      name="department"
                      onChange={handleChangeDepartment}
                      ref={register({ required: true })}
                    >
                      <option key="" value="">
                        Select
                      </option>
                      {allDepartments.map((ele, i) => {
                        return (
                          <option key={i} value={ele.id}>
                            {ele.name}
                          </option>
                        );
                      })}
                    </select>
                    {/* {loginOTPSResponse.length > 0 ? (
                      <div className="input-group-append">
                        <button
                          className="btn btn-secondary pl-11 "
                          type="button"
                          id="button-addon2"
                          onClick={getOTP}
                          disabled={otpButtonDisabled || departmentList === ""}
                        >
                          <span className="pr-10">{login.GET_OTP}</span>
                        </button>
                      </div>
                    ) : (
                      <div className="input-group-append">
                        <button
                          className="btn btn-secondary pl-11"
                          type="button"
                          id="button-addon2"
                          onClick={getOTP}
                          disabled={departmentList === ""}
                        >
                          <span className="pr-10">{login.GET_OTP}</span>
                        </button>
                      </div>
                    )} */}
                  </div>

                  {_.get("department.type", errors) === "required" && (
                    <p className="errorText">
                      {login.validationMessage.DEPT_REQ}
                    </p>
                  )}
                  {otpButtonDisabled && loginOTPSResponse.length > 0 ? (
                    <p className="Note-color font-11">
                      New OTP will be generated after <span id="timer"></span>{" "}
                      seconds.
                    </p>
                  ) : (
                    <p className="Note d-none">
                      New OTP will be generated after <span id="timer"></span>{" "}
                      seconds.
                    </p>
                  )}
                </div>

                {/* <div className="form-group col-md-12">
                  <label className="LeftText">
                    {" "}
                    {login.ENTER_EMAIL_OTP}
                    {!verifyEmailOtpFlag ? (
                      <span className="color-red">*</span>
                    ) : (
                      ""
                    )}
                  </label>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      maxLength={6}
                      name="OTP_email"
                      id="OTP_email"
                      ref={register({ required: !verifyEmailOtpFlag })}
                      aria-label="emailotp"
                      aria-describedby="button-addon2"
                      disabled={verifyEmailOtpFlag}
                    />
                    <div className="input-group-append">
                      <button
                        className="btn btn-secondary pl-11"
                        type="button"
                        id="button-addon2"
                        onClick={() => {
                          verificationLoginEmailOTPs("email");
                        }}
                        disabled={verifyEmailOtpFlag}
                      >
                        <span className="pr-10">{login.VERIFY_OTP}</span>
                      </button>
                    </div>
                  </div>
                  {_.get("OTP_email.type", errors) === "required" && (
                    <p className="errorText">
                      {login.validationMessage.OTP_REQ}
                    </p>
                  )}
                </div>
                <div className="form-group col-md-12">
                  <label className="LeftText">
                    {" "}
                    Enter Mobile OTP
                    {!verifyMobileOtpFlag ? (
                      <span className="color-red">*</span>
                    ) : (
                      ""
                    )}
                  </label>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      maxLength={6}
                      name="OTP_mobile"
                      ref={register({ required: !verifyMobileOtpFlag })}
                      aria-label="mobileotp"
                      aria-describedby="button-addon2"
                      disabled={verifyMobileOtpFlag}
                    />
                    <div className="input-group-append">
                      <button
                        className="btn btn-secondary pl-11"
                        type="button"
                        id="button-addon2"
                        onClick={() => {
                          verificationLoginMobileOTPs("mobile");
                        }}
                        disabled={verifyMobileOtpFlag}
                      >
                        <span className="pr-10">{login.VERIFY_OTP}</span>
                      </button>
                    </div>
                  </div>
                  {_.get("OTP_mobile.type", errors) === "required" && (
                    <p className="errorText">
                      {login.validationMessage.OTP_REQ}
                    </p>
                  )}
                </div> */}
              </div>
            </div>

            <div className="form-group col-md-6 pl-10 pr-10 ">
              <div className="row d-flex justify-content-center">
                <div className="form-group col-md-11">
                  <label className="LeftText">
                    {" "}
                    {login.PASSWORD} <span className="color-red">*</span>
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    id="password"
                    name="password"
                    ref={register({ required: true })}
                  />
                  {_.get("password.type", errors) === "required" && (
                    <p className="errorText">
                      {login.validationMessage.PASSWORD_REQUIRED}
                    </p>
                  )}
                  <div className="rightText">
                    <span onClick={reDirectToForgotPassword}>
                      <Link to="/forgotPassword">{login.FORGOT_PASSWORD}</Link>
                    </span>
                  </div>
                </div>
              </div>
              <div className="form-group col-md-12">
                <div className="form-group bgColor-FAFAFA">
                  <div className="form-group col-md-12 background-field">
                    {captchaId !== 0 && captchaId !== undefined ? (
                      <img
                        // src={`/epms/api/v1/admin/otps/${captchaId}`}
                        src={`${captchaUrl}/${captchaId}`}
                        id="captchaimage"
                        alt="captcha"
                      />
                    ) : (
                      ""
                    )}
                    <span className="ml-15">
                      {" "}
                      <i
                        className="cursorPointer fa fa-refresh fa-lg "
                        onClick={() => {
                          dispatch(generateCaptcha());
                        }}
                      />
                    </span>
                    <label className="LeftText">
                      {" "}
                      {login.ENTER_THE_TEXT_AS_ABOVE_IMAGE}
                      <span className="color-red">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleFormControlInput2"
                      name="enteredCaptcha"
                      autoComplete="off"
                      ref={register({ required: true })}
                    />
                    {_.get("enteredCaptcha.type", errors) === "required" && (
                      <p className="errorText">
                        {login.validationMessage.FIELD_REQ}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="form-group d-flex justify-content-center col-md-12">
                <button
                  type="submit"
                  className="color-white bgColor-0057C1 btn btn-primary col-md-12"
                  disabled={!formState.isValid}

                >
                  Login
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-2 border border-light"></div>
      </div>
    </form>
  );
}
